import { tableCacheKeys } from 'constants/tableCacheKeys';
import { TourStep } from 'core/tour';
import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';

import { useDailyCostSpendDetailsData, useReportDownload } from './_hooks';
import { DailyComputeSpendTable } from './DailyComputeSpendTable';
import { isStorageReportsSupported } from '../../../../../utils';
import { costOverTimeTourId, tourSteps } from '../../../../tourSteps';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const DailyComputeSpendDetails = () => {
  const { hasGpuData, hasTpuData } = useCostReportContext();
  const { data, isLoading } = useDailyCostSpendDetailsData();
  const { cluster } = useCluster();
  const showStorage = isStorageReportsSupported(cluster);

  const { download } = useReportDownload('daily-compute-spend-details', data, {
    hasGpu: hasGpuData,
    hasTpu: hasTpuData,
  });

  return (
    <TourStep
      step={tourSteps.dailyComputeSpendDetails}
      type={costOverTimeTourId}
      text="Scroll through the breakdown of your cluster costs over the entire month until today. "
      highlight="shadow"
      placement="top"
    >
      <div className="tour-highlight" data-hc="success">
        <DailyComputeSpendTable
          data={data}
          isLoading={isLoading}
          hasGpuData={hasGpuData}
          hasTpuData={hasTpuData}
          showStorage={showStorage}
          cacheKey={
            tableCacheKeys.COST_MONITORING.WORKLOADS.DETAILS.COMPUTE_SPEND
          }
          testId="daily-compute-spend-details"
          onDownload={() => download()}
        />
      </div>
    </TourStep>
  );
};
